import React, { PropsWithChildren } from "react";
import { Row } from "antd";
import { RowProps } from "antd/lib/row";

interface ButtonsRowProps extends PropsWithChildren<RowProps> {}

export const ButtonsRow: React.FC<ButtonsRowProps> = (props) => {
  return (
    <Row style={{ marginTop: 20 }} {...props} justify={props.justify || "end"}>
      {props.children}
    </Row>
  );
};
